import type { ReactNode } from "react";

// Props comuns aos campos de data e hora (DataField, HoraField). O valor é texto no formato que
// o servidor usa; "" é campo vazio.
export interface CampoPickerProps {
  label: string;
  value: string;
  onChange: (valor: string) => void;
  required?: boolean;
  error?: boolean;
  helperText?: ReactNode;
  fullWidth?: boolean;
  size?: "small" | "medium";
  disabled?: boolean;
  // Nome acessível quando o rótulo visível se repete na tela (ex.: "Entrada" em vários blocos).
  ariaLabel?: string;
}

// Campo de texto do picker: o rótulo fica sempre em cima, com o formato (dd/mm/aaaa, hh:mm) à
// mostra, para não disputar espaço com o ícone.
export function textFieldDoCampo({ required, error, helperText, fullWidth, size, ariaLabel }: CampoPickerProps) {
  return {
    required,
    error,
    helperText,
    fullWidth,
    size,
    slotProps: { inputLabel: { shrink: true }, htmlInput: { "aria-label": ariaLabel } },
  };
}
